import { useState } from 'react';

// Detected once per session from the device itself (not the current window size), so
// resizing/shrinking a desktop browser window keeps the desktop layout instead of
// falling back to the mobile design.
export const detectIsDesktopDevice = (): boolean => {
    if (typeof window === 'undefined') return true;
    const isTouchOnly = window.matchMedia?.('(hover: none) and (pointer: coarse)').matches ?? false;
    const isMobileUA = /Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent || '');
    if (isTouchOnly || isMobileUA) return false;
    return Math.max(window.screen?.width || 0, window.screen?.height || 0) >= 900;
};

export const useIsDesktopDevice = (): boolean => {
    const [isDesktop] = useState(detectIsDesktopDevice);
    return isDesktop;
};
